export enum QuarantineStatusType {
  Open = 0,
  Accomplished = 1,
}
